import { render, staticRenderFns } from "./TrainersList.vue?vue&type=template&id=b30a04f2&scoped=true&lang=pug&"
import script from "./TrainersList.vue?vue&type=script&lang=js&"
export * from "./TrainersList.vue?vue&type=script&lang=js&"
import style0 from "./TrainersList.vue?vue&type=style&index=0&id=b30a04f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30a04f2",
  null
  
)

export default component.exports